<template>
  <Teleport to="body">
    <div
      v-if="selectedImage"
      class="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-8"
      @click="selectedImage = null"
    >
      <div class="relative">
        <img
          :src="selectedImage.url"
          :alt="selectedImage.alt"
          class="max-w-screen-lg w-full"
        />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          class="size-8 absolute top-0 right-0 m-4 cursor-pointer text-white"
          @click="selectedImage = null"
        >
          <path
            fill-rule="evenodd"
            d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
    </div>
  </Teleport>

  <div class="grid-slider-container w-full">
    <swiper
      :modules="[SwiperGrid, SwiperPagination, SwiperNavigation]"
      :slides-per-view="3"
      :grid="{ rows: 4, fill: 'row' }"
      :space-between="16"
      :pagination="{ clickable: true }"
      :navigation="{
        nextEl: '.custom-next',
        prevEl: '.custom-prev',
      }"
      class="w-full"
    >
      <swiper-slide v-for="(image, index) in [...props.data]" :key="index">
        <img
          :src="image.url"
          :alt="image.alt || `Image ${index + 1}`"
          class="w-full object-cover aspect-square rounded-lg shadow-md m-0"
          @click="selectedImage = image"
        />
      </swiper-slide>
    </swiper>

    <!-- Custom navigation buttons outside the swiper -->
    <div class="flex justify-between items-center mt-4">
      <button class="custom-prev">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="w-6 h-6"
        >
          <path d="M15 18l-6-6 6-6" />
        </svg>
      </button>
      <button class="custom-next">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="w-6 h-6"
        >
          <path d="M9 18l6-6-6-6" />
        </svg>
      </button>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, defineProps } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import {
  Grid as SwiperGrid,
  Pagination as SwiperPagination,
  Navigation as SwiperNavigation,
} from 'swiper'
// Import Swiper styles
import 'swiper/css'
import 'swiper/css/grid'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

const props = defineProps(['data'])
const selectedImage = ref(null)
</script>
<style>
/* Additional custom styles */
.swiper {
  width: 100%;
  height: 100%;
}
.custom-prev,
.custom-next {
  width: 40px;
  height: 40px;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  color: #3498db;
  border: none;
}
/* Hide default navigation arrows */
.swiper-button-next,
.swiper-button-prev {
  display: none !important;
}
</style>
